import * as React from 'react';
function SvgSmallRightArrow(props) {
  return (
    <svg width={13} height={13} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.913 2l4.95 4.95-4.95 4.95" stroke="#BDBDBD" strokeWidth={3} />
    </svg>
  );
}
export default SvgSmallRightArrow;
